// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a765d7c","453":"cca50dcd","455":"b405adab","465":"e597b939","834":"51ba41ea","977":"f362e123"}[chunkId] + ".chunk.js";
};